import { createThunk } from '../services/create-thunk';
import { getCompId, getViewMode, getExternalId } from '../services/wix-sdk-utils';

export const FETCH_APP_SETTINGS_REQUEST = 'appSettings/FETCH_REQUEST';
export const FETCH_APP_SETTINGS_SUCCESS = 'appSettings/FETCH_SUCCESS';
export const FETCH_APP_SETTINGS_FAILURE = 'appSettings/FETCH_FAILURE';

export const fetchAppSettingsRequest = () => ({
  type: FETCH_APP_SETTINGS_REQUEST,
});
export const fetchAppSettingsSuccess = payload => ({
  type: FETCH_APP_SETTINGS_SUCCESS,
  payload,
});
export const fetchAppSettingsFailure = () => ({
  type: FETCH_APP_SETTINGS_FAILURE,
});

export function fetchAppSettings(search) {
  return createThunk((dispatch, getState, { request }) => {
    dispatch(fetchAppSettingsRequest());

    let compId = getCompId(search);
    compId = compId === '' ? 'default' : compId;

    let viewMode = getViewMode(search);
    viewMode = viewMode === '' ? 'site' : viewMode;

    return request(`/_api/settings?compId=${compId}&externalId=${getExternalId(search)}&viewMode=${viewMode}`)
      .then(settings => dispatch(fetchAppSettingsSuccess(settings)))
      .catch(() => dispatch(fetchAppSettingsFailure()));
  });
}

export function fetchPageAppSettings(search) {
  return createThunk((dispatch, getState, { request }) => {
    dispatch(fetchAppSettingsRequest());

    let viewMode = getViewMode(search);
    viewMode = viewMode === '' ? 'site' : viewMode;

    return request(`/_api/settings/page?viewMode=${viewMode}`)
      .then(settings => dispatch(fetchAppSettingsSuccess(settings)))
      .catch(() => dispatch(fetchAppSettingsFailure()));
  });
}



// WEBPACK FOOTER //
// ./app/actions/fetch-app-settings.js